import { observable } from 'mobx';

function isJSON(x: unknown): x is string {
  try {
    JSON.parse(x as string);
    return true;
  } catch (parseException) {
    return false;
  }
}

export class PersistentStorage {
  protected inMemoryStore = observable.map();

  public set(key: string, value: string | object) {
    const finalValue = typeof value === 'object' ? JSON.stringify(value) : value;
    window.localStorage.setItem(key, finalValue);
    this.inMemoryStore.set(key, value);
    return this;
  }

  public get(key: string) {
    if (this.inMemoryStore.has(key)) {
      return this.inMemoryStore.get(key);
    } else {
      const value = window.localStorage.getItem(key);
      return isJSON(value) ? JSON.parse(value) : value;
    }
  }

  public has(key: string) {
    return this.inMemoryStore.has(key) || window.localStorage.getItem(key) !== null;
  }

  public delete(key: string) {
    window.localStorage.removeItem(key);
    this.inMemoryStore.delete(key);
    return this;
  }
}
